/**
 * Simple CSRF Token Utility
 */

import { env } from '@/constants/configs'

/**
 * Fetch CSRF token from API Gateway
 * @param commonData Optional common data that might contain CSRF_TOKEN
 * @returns Promise<string> CSRF token
 */
export async function getCSRFToken(commonData?: any): Promise<string> {
  // Priority: Use provided token if available
  if (commonData?.CSRF_TOKEN) {
    return commonData.CSRF_TOKEN
  }

  // Fetch from API Gateway
  try {
    const response = await fetch(`${env.API_GATEWAY}/api/crsf-token/`, {
      method: 'GET',
      credentials: 'include',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/json'
      }
    })

    if (!response.ok) {
      throw new Error(`Failed to fetch CSRF token: ${response.status} ${response.statusText}`)
    }

    const data = await response.json()

    if (!data.csrf_token && !data.token) {
      throw new Error('CSRF token not found in API response')
    }

    return data.csrf_token || data.token
  } catch (error) {
    console.error('Error fetching CSRF token:', error)
    throw error
  }
}
